import React from 'react'
import AllNftCard from './AllNftCard'
import AllNftSidebar from './AllNftSidebar'

const AllNft = () => {
    const allnftCardItem = [ 1,2,3,4,5,6,7,8,9,10,11,12];
    return (
        <>
            <div className="_nft_expnew_wrapper">
                <div className="_nft_expnew_wrap">
                    <div className="_nft_expnew_container">
                        <AllNftSidebar />
                        <div className="_nft_expnew_main_wrap">
                            <div className="_nft_expnew_main_inner">
                                <div className="row">
                                    {
                                        allnftCardItem.map((item,id)=>
                                        <AllNftCard key={id} />
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AllNft